const srmconfig={
    "plat":{
        ct: "pc"
    },
    "portal":{
        ct: "sp"
    }
}
import env from './env.json'

export default srmconfig[env.env]